/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountCategoryEnum } from './accountCategoryEnum';
import { AccountProviderTypeEnum } from './accountProviderTypeEnum';
import { AccountStateEnum } from './accountStateEnum';


export interface AccountResponseSpec { 
    /**
     * Account id
     */
    account_id: string;
    /**
     * Name for an account.
     */
    account_name?: string;
    provider: AccountProviderTypeEnum;
    state: AccountStateEnum;
    category: AccountCategoryEnum;
    /**
     * Batch Id to which this account belongs.
     */
    batch_id: string;
    /**
     * Owner account Id.
     */
    master_account_id: string;
    /**
     * Used for partitioning accounts.
     */
    org_unit?: string;
    /**
     * Team to which account belongs.
     */
    team?: string;
    /**
     * Email-id of user who sent onboarding request
     */
    onboarded_by: string;
    /**
     * Time when account is onboarded.
     */
    onboarded_on: Date;
    /**
     * Any comment related to account.
     */
    note?: string;
}
export namespace AccountResponseSpec {
}


